import { defineComponent as _defineComponent } from 'vue';
import CompanyMenuItem from './CompanyMenuItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CompanyMenuLinks',
    props: {
        responsive: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const __returned__ = { props, CompanyMenuItem };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
